<template>
  <div class="w-full vx-coll-fixed-height">
    <vs-divider position="left" class="text-xl">{{ $t('sections.prosecution.dataForm.title.normal') }}</vs-divider>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.caseDate") }}</h6>
        <p>{{ _prosecution.caseDate | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.caseNumber") }}</h6>
        <p>{{ _prosecution.caseNumber || '-' }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.lawyer") }}</h6>
        <p>{{ _prosecution.lawyer.fullName || '-' }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.borrower") }}</h6>
        <p>{{ _prosecution.borrower.fullName || '-' }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.contract") }}</h6>
        <p>{{ _prosecution.contract.contractNo || '-' }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.sureties") }}</h6>
        <p>{{ _prosecution.sureties.map(({surety}) => surety.fullName).join(', ') }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.firstMissedAppointmentDate") }}</h6>
        <p>{{ _prosecution.firstMissedAppointmentDate | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.firstCollectionFeeLetterDate") }}</h6>
        <p>{{ _prosecution.firstCollectionFeeLetterDate | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.sendCollectionFeeLetterCount") }}</h6>
        <p>{{ _prosecution.sendCollectionFeeLetterCount }}</p>
      </div>
    </div>
    <vs-divider position="left" class="text-xl">{{ $t('sections.prosecution.dataForm.title.asset') }} </vs-divider>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.dateOfBalanceExtraction") }}</h6>
        <p>{{ _prosecution.dateOfBalanceExtraction | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.principle") }}</h6>
        <p>{{ _prosecution.principle | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.interest") }}</h6>
        <p>{{ _prosecution.interest | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.penalty") }}</h6>
        <p>{{ _prosecution.penalty  | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.fee") }}</h6>
        <p>{{ _prosecution.fee  | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.expenseDetailAmount") }}</h6>
        <p>{{ _prosecution.expenseDetailAmount  | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.collectionFee") }}</h6>
        <p>{{ _prosecution.collectionFee  | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.lawyerFee") }}</h6>
        <p>{{ _prosecution.lawyerFee  | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.totalAsset") }}</h6>
        <p>{{ _prosecution.total  | numberFormat }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const { mapState: mapProsecutionFields } = createNamespacedHelpers('Prosecution')

export default {
  name: "UserJobInfoTab",
  components: {},
  props: {},
  computed: {
    ...mapProsecutionFields(['prosecution']),
    _prosecution() {
      if(!this.prosecution) return null
      return {
       ...this.prosecution
      }
    },
  },
};
</script>

<style scoped>
.vx-coll-fixed-height{
  display:block;
  width:100%;
  height:555px;
  overflow: auto;
}
</style>
